var exports = {
  "C": "animated___n3Rbz",
};

module.exports = exports;
